// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Report from "@material-ui/icons/Report";
import Reconciliation from "@material-ui/icons/RestorePage";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Settlement from "@material-ui/icons/Style";
import Flight from "@material-ui/icons/Flight";
import Audit from "@material-ui/icons/TrackChanges";
import WalletIcon from "@material-ui/icons/Flight";
import Landing from "@material-ui/icons/FlightLandOutlined";

import Reports from "layouts/recordsLanding/recordsLanding.jsx";
import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import DashboardPage from "views/Dashboard/Dashboard.jsx";
import AirlinesPassengerPage from "views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import BillablePassengers from "views/BillablePassengers/Index.jsx";
import Audits from "views/AuditTrail/Index.jsx";
import PSCUtilization from "views/PSCUtilization/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";
import WalletReport from "views/WalletReport";
import Transit from "views/Transit/Index.jsx";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

const routes = [
    {
        path: "/main-landing",
        sidebarName: "Main Landing",
        navbarName: "Main Landing",
        icon: Landing,
        component: MainLandingPage,
        subMenu: [],
    },
    {
        path: "/app/dashboard",
        sidebarName: "Dashboard",
        navbarName: "Dashboard",
        icon: Dashboard,
        component: DashboardPage,
        subMenu: [],

    },
//     {
//         path: "/app",
//         sidebarName: "Dashboard",
//         isNotVisible: true,
//         navbarName: "Dashboard",
//         icon: Dashboard,
//         subMenu: [],
//         component: DashboardPage
// },
//     {
//         path: "/app/dashboard",
//         sidebarName: "Dashboard",
//         isNotVisible: true,
//         navbarName: "Dashboard",
//         icon: Dashboard,
//         subMenu: [],
//         component: DashboardPage
//     },
    {
        path: "/app/passenger-data",
        sidebarName: "Passenger Data",
        navbarName: "Airline Passenger Data",
        icon: Passenger,
        subMenu: [],
        component: AirlinesPassengerPage
    },
    {
        path: "/app/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
        path: "/app/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    // {
    //     path: "/app/outstanding-settlement",
    //     sidebarName: "Outstanding Settlement",
    //     navbarName: "Outstanding Settlement",
    //     icon: Settlement,
    //       subMenu: [],
    //       component: OutstandingSettlementPage
    //   },
    {
        path: "/app/audits",
        sidebarName: "Audit Trail",
        navbarName: "Audit Trail",
        icon: Audit,
        subMenu: [],
        component: Audits,
    },
    {
        path: "/reports-landing",
        sidebarName: "PSC Reports",
        navbarName: "Psc Reports",
        icon: Report,
        component: Reports,
        subMenu: [],

    },
    {
        path: "/app/psc-utilization",
        sidebarName: "PSC Utilization",
        isNotVisible: true,
        navbarName: "PSC Utilization",
        icon: Dashboard,
        component: PSCUtilization,
        subMenu: [],

    },
    {
        path: "/app/billable-passengers",
        sidebarName: "Billable Passengers",
        isNotVisible: true,
        navbarName: "Total Passengers vs Billable Passengers",
        icon: BillablePassengers,
        component: BillablePassengers,
        subMenu: [],

    },
    {
        path: "/app/wallet-report",
        sidebarName: "Airline Wallet Report",
        isNotVisible: true,
        navbarName: "Airline Wallet Report",
        icon: WalletIcon,
        component: WalletReport,
        subMenu: [],

    },
    {
        path: "/app/transit-passenger-report",
        sidebarName: "Transit Report",
        navbarName: "Transit Report",
        isNotVisible: true,
        icon: Reconciliation,
        component: Transit,
        subMenu: []
    },
    // {
    //     path: "/app/statement-of-account",
    //     sidebarName: "Account Statement",
    //     isNotVisible: true,
    //     navbarName: "Account Statement",
    //     icon: Reconciliation,
    //     component: StatementOfAccount,
    //     subMenu: []
    // },
    {
        path: "/app/psc-regional/help-center",
        sidebarName: "Help Center",
        navbarName: "Help Center",
        icon: HelpIcon,
        component: HelpCenter,
        subMenu: []
      },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/vggUser.jsx